"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _findIllus = _interopRequireDefault(require("../../../assets/images/find-illus.svg"));
var _hooks = require("../../../hooks");
var _services = require("../../../services");
var _icons = require("../../icons");
var _fakeEmployees = _interopRequireDefault(require("./fake-employees"));
var _header = _interopRequireDefault(require("./header"));
var _item = _interopRequireDefault(require("./item"));
var _rankCard = _interopRequireDefault(require("./rank-card"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IndividualLeaderboard({
  FakeItemsCard,
  Button: _Button,
  enableHeader,
  event,
  currentUser,
  search,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  isFree,
  setSearch
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [tmpSearch, setTmpSearch] = (0, _react.useState)(search);
  const [page, setPage] = (0, _react.useState)(1);
  const [leaderboard, setLeaderboard] = (0, _react.useState)();
  const [count, setCount] = (0, _react.useState)();
  const [userItem, setUserItem] = (0, _react.useState)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  const {
    cancellablePromise: cancellableUserItemPromise,
    cancelPromises: cancelUserItemPromise
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    if (initialized) {
      if (currentUser) getUserItem();else if (currentUser === null) setUserItem(null);
    }
    setInitialized(true);
    return () => {
      cancelUserItemPromise();
      setUserItem(undefined);
    };
  }, [initialized, currentUser]);
  (0, _react.useEffect)(() => {
    if (initialized) {
      if (page > 1) setPage(1);
      getLeaderboard(1);
    }
    return () => {
      cancelPromises();
      setLeaderboard(undefined);
    };
  }, [initialized, search]);
  (0, _react.useEffect)(() => {
    if (page > 1) getLeaderboard(page);
  }, [page]);
  async function getUserItem() {
    try {
      const {
        items: [userItem]
      } = await cancellableUserItemPromise(_services.EventService.getIndividualRanking(event.id, {
        page: 1,
        pageSize: 1,
        getConnectedUserRank: true
      }));
      setUserItem(userItem || null);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
  }
  async function getLeaderboard(page) {
    setLoading(true);
    try {
      const {
        count,
        items
      } = await cancellablePromise(_services.EventService.getIndividualRanking(event.id, {
        page,
        pageSize: isFree ? freeOfferEmployeesLeaderboardsMaxRowsCount : 10,
        search
      }));
      setCount(count);
      if (page === 1) setLeaderboard(items);else setLeaderboard([...(leaderboard || []), ...items]);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
    setLoading(false);
  }
  const Button = _Button || _Button3.default;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3,
    sx: {
      containerType: 'inline-size'
    },
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    margin: "none",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setTmpSearch(value),
    onKeyDown: ({
      key
    }) => {
      if (key === 'Enter') setSearch(tmpSearch);
    },
    placeholder: t('commons.challenges.leaderboard.search_cyclist'),
    size: "small",
    slotProps: {
      input: {
        endAdornment: tmpSearch && /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
          title: "Rechercher"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
          disabled: !tmpSearch,
          onClick: () => setSearch(tmpSearch),
          size: "small"
        }, /*#__PURE__*/_react.default.createElement(_icons.SearchIcon, {
          fontSize: "small"
        })))))
      }
    },
    sx: {
      '.MuiInputBase-root': {
        bgcolor: '#fff'
      }
    },
    type: "text",
    value: tmpSearch,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement(_rankCard.default, {
    challengeTemplate: event.challengeTemplate,
    numberOfParticipants: count,
    progress: userItem
  }), !leaderboard || leaderboard.length > 0 ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  }, enableHeader && /*#__PURE__*/_react.default.createElement(_header.default, {
    event: event
  }), leaderboard ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, leaderboard.map((item, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: item.user.id
  }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    item: item,
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))), isFree && count && count > freeOfferEmployeesLeaderboardsMaxRowsCount && /*#__PURE__*/_react.default.createElement(_fakeEmployees.default, {
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferEmployeesLeaderboardsMaxRowsCount
  })) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  })))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 64,
    src: _findIllus.default
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description')))), !isFree && leaderboard && count && count > leaderboard.length ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: loading,
    endIcon: loading && /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    onClick: () => setPage(page + 1),
    size: "small",
    variant: "outlined"
  }, t('commons.actions.see_more'))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
}
var _default = exports.default = IndividualLeaderboard;